import { render, staticRenderFns } from "./Preanestesia.vue?vue&type=template&id=4db726a2"
import script from "./Preanestesia.vue?vue&type=script&lang=js"
export * from "./Preanestesia.vue?vue&type=script&lang=js"
import style0 from "./Preanestesia.vue?vue&type=style&index=0&id=4db726a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports